import { render, staticRenderFns } from "./CustomerSearchAutocomplete.vue?vue&type=template&id=47646bc8&scoped=true&"
import script from "./CustomerSearchAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearchAutocomplete.vue?vue&type=style&index=0&id=47646bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47646bc8",
  null
  
)

export default component.exports